import { gql } from '@apollo/client'

export const CORE_INSURANCE_POLICY_FIELDS = gql`
  fragment CoreInsurancePolicyFields on InsurancePolicy {
    id
    initialAppointmentKind {
      key
      title
      duration
    }
    unitsLeft
    unitsUsed
    unitsAuthorized
    unitsOccurred
    lastState {
      id
      kind
      reason
    }
    last
    eligible
    inReview
    declined
    hasUnusedCalls
    hasUnlimitedCalls
  }
`
